import { reactive, ref } from 'vue'
import type { FormInstance, FormItemProp } from 'element-plus/lib/components'
import type { ContainerType, ShippingLine } from '~/services/apiClient'
import { CONTAINER_RE } from '~/utils'

interface UseSwapEmptyFormProps {
  shippingLine?: ShippingLine
  containerType?: ContainerType
  prefillContainerNumber?: string | null
}

export function useSwapEmptyForm(props: UseSwapEmptyFormProps) {
  const formRef = ref<FormInstance>()
  const EMPTY_CONTAINER_FIELD_NAME = ref('empty_container_number')

  const form = reactive({
    empty_container_number: props.prefillContainerNumber || '',
    shipping_line: props.shippingLine as ShippingLine | undefined,
    container_type: props.containerType as ContainerType | undefined,
    chassis_number: null,
  })

  const formRules = reactive({
    empty_container_number: [
      {
        required: true,
        message: 'Required',
        trigger: 'change',
      },
      {
        trigger: 'change',
        pattern: CONTAINER_RE,
        message: 'Invalid container number',
      },
    ],
    shipping_line: [
      {
        required: true,
        message: 'Required',
        trigger: 'change',
      },
    ],
    container_type: [
      {
        required: true,
        message: 'Required',
        trigger: 'change',
      },
    ],
    chassis_number: [
      {
        required: false,
        message: 'Required',
        trigger: 'change',
      },
    ],
  })

  async function validateField(
    prop: FormItemProp,
    isValid: boolean,
    onValidateEmptyContainer?: () => Promise<void>
  ) {
    if (
      prop === EMPTY_CONTAINER_FIELD_NAME.value &&
      isValid &&
      onValidateEmptyContainer
    ) {
      await onValidateEmptyContainer()
    }
  }

  async function validateForm(): Promise<boolean> {
    if (!formRef.value) return false
    return await formRef.value.validate()
  }

  return {
    // Refs
    formRef,
    EMPTY_CONTAINER_FIELD_NAME,
    form,
    formRules,

    // Methods
    validateField,
    validateForm,
  }
}
